module.exports = __webpack_public_path__ + "static/img/manual_zh_22.0979d26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_22.png
// module id = TjQ2
// module chunks = 4